import React from 'react'
import Plot from 'react-plotly.js'

export default function BarChart1({ data }) {
    const xvalue = data ? data?.map((item) => item?.total_amount) : []
    const convertString = (string) => {
        if (typeof string === 'string') {
            let arr = string
                .toLowerCase()
                .split('_')
                .map((item) => item.charAt(0)?.toUpperCase())
            return arr.join(' ')
        }
    }
    const yvalue = data
        ? data?.map(
              (item) =>
                  ['other_charges', 'remaining_other_charges'].includes(
                      item?.surcharge,
                  )
                      ? 'Other Charges'
                    //   : item?.surcharge,
              : convertString(item?.surcharge),
          )
        : []

    const generateColors = (count) => {
        const colors = [
            '#4285F4',
            '#10B981',
            '#F59E0B',
            '#EF4444',
            '#8B5CF6',
            '#06B6D4',
            '#EC4899',
            '#F97316',
            '#14B8A6',
            '#A855F7',
            '#3B82F6',
            '#22C55E',
            '#EAB308',
            '#EF4444',
            '#8B5CF6',
        ]

        // If we need more colors than defined, generate additional ones
        if (count > colors.length) {
            for (let i = colors.length; i < count; i++) {
                const hue = (i * 137.5) % 360 // Golden angle for good color distribution
                colors.push(`hsl(${hue}, 70%, 55%)`)
            }
        }

        return colors.slice(0, count)
    }

    const colors = generateColors(yvalue.length)

    const convertDescription = (string) => {
        if (typeof string === 'string') {
            let arr = string
                .toLowerCase()
                .split('_')
                .map((item) => item.charAt(0)?.toUpperCase() + item.slice(1))
            return arr.join(' ')
        }
    }

    return (
        <div className="rounded-lg bg-white px-6 pt-6 pb-6 shadow-sm">
            <h4 className="font-bold text-black text-lg mb-4">
                Top 5 Surcharges
            </h4>
            <div>
                <Plot
                    data={[
                        {
                            x: [...xvalue],
                            y: [...yvalue],
                            type: 'bar',
                            orientation: 'h',
                            marker: {
                                color: colors,
                            },
                        },
                    ]}
                    layout={{
                        showlegend: false,
                        xaxis: {
                            tickformat: ',.0f',
                            tickprefix: 'A$',
                            gridcolor: '#E5E7EB',
                            showline: false,
                            rangemode: 'tozero',
                        },
                        yaxis: {
                            showgrid: false,
                            showline: false,
                        },
                        plot_bgcolor: 'white',
                        paper_bgcolor: 'white',
                        margin: {
                            l: 140,
                            r: 20,
                            t: 20,
                            b: 40,
                        },
                        bargap: 0.3,
                    }}
                    config={{
                        displayModeBar: false,
                        responsive: true,
                    }}
                    useResizeHandler={true}
                    style={{ width: '100%', height: '350px' }}
                />
            </div>

            {/* Color Labels Section */}
            <div className="mt-4 flex flex-wrap gap-4 justify-center border-t pt-4">
                {data?.map((item, index) => (
                    <div key={index} className="flex items-center gap-2">
                        <div
                            className="w-4 h-4 rounded"
                            style={{ backgroundColor: colors[index] }}
                        />
                        <span className="text-sm text-gray-700">
                            {[
                                'other_charges',
                                'remaining_other_charges',
                            ].includes(item?.surcharge)
                                ? 'Other Charges'
                                // : item?.surcharge}{' '}
                            : convertString(item?.surcharge)}{' '}-{' '}
                            {item?.surcharge === 'remaining_other_charges'
                                ? 'Remaining Other Charges'
                                : item?.description ||
                                  convertDescription(item?.surcharge)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}
